import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type { GetAdminPlaybookResponse, UsePlaybookParams, UsePlaybookResult } from './types';

const usePlaybook = ({ playbookId, enabled = true }: UsePlaybookParams): UsePlaybookResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<GetAdminPlaybookResponse>({
        pathname: `/admin/playbooks/${encodeURIComponent(playbookId)}`,
        method: 'GET',
        key: `admin-playbook-${playbookId}`,
        queryOptions: { enabled: enabled && playbookId.length > 0 },
    });

    return {
        playbook: data?.data.playbook || null,
        isLoadingPlaybook: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default usePlaybook;
